import showToast from '../components/ToastComponent';
import instance from '../config/axios';
import { calculateOutOfStockEnum } from '../utils/outOfStockStatus';
import { Endpoints } from './endPoints';

export const getGuestBundledAccessories = async (cart?: any[]) => {
  try {
    const result = await instance({
      url: Endpoints.GET_BUNDLES,
      method: 'GET',
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const quantityCheckedAccessories = result?.data?.map((product: any) => {
      const cartItem = cart?.find(
        (item: any) => `${item.product_id}` === `${product.product_code}`,
      );
      const orderedQuantity = cartItem?.quantity ?? 0;

      return {
        ...product,
        orderedQuantity,
        outOfStock: calculateOutOfStockEnum(product, orderedQuantity),
      };
    });

    if (!quantityCheckedAccessories) {
      showToast({
        message: 'Unable to fetch bundled accessories!',
        type: 'info',
      });
      return [];
    }
    return quantityCheckedAccessories;
  } catch (error) {
    console.error('Error fetching guest bundled accessories:', error);
    showToast({
      message: 'Error fetching bundled accessories!',
      type: 'error',
    });
    return [];
  }
};
